import { FormattedMessage, useIntl } from 'react-intl'
import { NotAccessContainer } from './styled-components'
import NotFoundComponent from '../stories/molecules/not-found'
import { Link } from 'react-router-dom'
import ButtonComponent from '../stories/atoms/button'
import { EmptyState } from '../stories/atoms/icons/core'

const iconStyle = {
  width: '140px',
  height: '140px',
  opacity: '0.5'
}

const NotAccessPageComponent = () => {
  const { formatMessage } = useIntl()

  const config = {
    header: formatMessage({ id: 'you_cant_view_this' }),
    description: formatMessage({ id: 'you_cant_view_this_description' }),
    icon: <EmptyState style={iconStyle} />
  }

  return (
    <NotAccessContainer>
      <NotFoundComponent
        icon={config.icon}
        header={config.header}
        description={config.description}
      />
      <ButtonComponent as={Link} to="/project">
        <FormattedMessage id="back_to_projects" />
      </ButtonComponent>
    </NotAccessContainer>
  )
}

export default NotAccessPageComponent
